import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, Switch } from "react-router-dom";
import Container from "../../core/ui/container";
import Grid from "../../core/ui/grid";
import NavNotifier from "../../core/ui/nav-notifier";
import WatchIntegrityWrapper from "../../core/ui/watchIntegrityWrapper";
import { actions } from "../../actions/main.actions";
import { Col } from "../../core/ui/grid";
import PrivateRoute from "../../core/ui/private-route";
import AccountCollection from "./account-collection";
import AccountBalance from "./account-profile";
import AccountSettings from "./account-settings";
import { AppLocation, IApplicationState } from "../../typings";

export interface AccountPageProps extends RouteComponentProps<any> {
    appLocation: AppLocation;
}

export interface AccountPageState {}

export class AccountPage extends React.Component<AccountPageProps & typeof actions, AccountPageState> {
    constructor(props: any) {
        super(props);

        this.state = {};
    }

    public getActiveClassFor = (section: string) => {
        return this.props.appLocation === section ? "selected" : "";
    };

    public handleSwitchSection = (uri, section) => {
        // this.props.changeLocation(section);
        this.props.history.push(uri);
    };

    public render() {
        const { history } = this.props;

        const redirectTo = "/account/balance";

        const sections = [
            {
                title: "My collection",
                section: "collection",
                uri: "/account/collection",
            },
            {
                title: "Account",
                section: "balance",
                uri: "/account/balance",
            },
            {
                title: "Settings",
                section: "settings",
                uri: "/account/settings",
            },
        ];

        return (
            <NavNotifier idk="light">
                <Container transparent={true} style={{ width: "100%", paddingLeft: 0 }}>
                    <div className="profile-page">
                        <Grid centered={true}>
                            <Col size={80}>
                                <div className="profile-navigation">
                                    {sections.map((item, index) => {
                                        return (
                                            <h2
                                                key={item.uri}
                                                className={this.getActiveClassFor(item.section)}
                                                onClick={() => this.handleSwitchSection(item.uri, item.section)}
                                            >
                                                {item.title}
                                            </h2>
                                        );
                                    })}
                                </div>
                            </Col>
                        </Grid>

                        <div className="section-divider mobile"></div>

                        <Switch location={history.location}>
                            <PrivateRoute exact={true} path={`${this.props.match.url}/collection`}>
                                <WatchIntegrityWrapper redirectTo={redirectTo} history={history}>
                                    <AccountCollection urlPreffix="collection" />
                                </WatchIntegrityWrapper>
                            </PrivateRoute>
                            <PrivateRoute exact={true} path={`${this.props.match.url}/balance`} component={AccountBalance} />
                            <PrivateRoute exact={true} path={`${this.props.match.url}/settings`} component={AccountSettings} />

                            <Container>
                                <div className="page-404">
                                    <h1>404 Page not found</h1>
                                    <p>We apologize for the inconvenient, we are working to improve the service.</p>
                                </div>
                            </Container>
                        </Switch>
                    </div>
                </Container>
            </NavNotifier>
        );
    }
}

function mapStateToProps(state: IApplicationState, ownProps) {
    return {
        ...ownProps,
        appLocation: state.appLocation,
    };
}

export default connect(mapStateToProps, { ...actions })(AccountPage);



// WEBPACK FOOTER //
// ./src/components/account/account-page.tsx